import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PostingsWbApi from '../../../../../API/shipment/postingsWb-api';
import { uiChangeWbViewSize } from '../../../../../actions/ui';
import { Column, Row, WhiteBlock } from '../../../../../components/Basic/Blocks';
import { Button, CheckButton, ExportExcelFileButton } from '../../../../../components/Basic/Buttons';
import { LinkBlue } from '../../../../../components/Basic/Elements';
import { Content } from '../../../../../components/Basic/Global';
import { InputLabel } from '../../../../../components/Basic/Inputs';
import { H1, Text, TextGrey } from '../../../../../components/Basic/WrapsStyle';
import { MAP_WB_SKLAD_NAME, MARKETS_MAP, TYPE_BUTTONS } from '../../../../../constans';
import { formFullDate } from '../../../../../utils';
import WbTableOrders from '../../Orders/TableOrders';
import WbTableSizes from '../../Orders/TableSizes';
import styles from '../styles.module.scss';

const MAP_WB = {
  'WB-1': 1,
  'WB-2': 2,
  'WB-3': 3,
  'WB-4': 4,
  'WB-5': 5,
  'WB-6': 6,
  'WB-7': 7,
  'WB-1 EKB': 1,
  'WB-2 EKB': 2,
  'WB-3 EKB': 3,
  'WB-4 EKB': 4,
  'WB-5 EKB': 5,
  'WB-6 EKB': 6,
  'WB-7 EKB': 7,
  'WB-1_EKB': 1,
  'WB-2_EKB': 2,
  'WB-3_EKB': 3,
  'WB-4_EKB': 4,
  'WB-5_EKB': 5,
  'WB-6_EKB': 6,
  'WB-7_EKB': 7,
};
function WbSuppliePage({ ...props }) {
  const match = useParams();
  const { id, shop } = match;
  console.log(shop);

  const [postings, setPostings] = useState([]);
  const [map, setMap] = useState({});
  const [supplie, setSupplie] = useState({ name: '' });

  const [dataBarcode, setDataBarcode] = useState({});
  const [dataMeta, setDataMeta] = useState({});

  const { is_check_size } = useSelector((store) => store.ui);

  const dispatch = useDispatch();
  // const { map } = useSelector((store) => store.wbOrders);

  const [showShipment, setShowShipment] = useState(false);

  const calcDownloadedData = useCallback(() => {
    let d = postings;

    d = d.map((item) => {
      const sticker = dataBarcode[item.order_id];

      const first = sticker ? sticker.partA : '';
      const second = sticker ? sticker.partB : '';
      const name = map[item.offer_id] ? map[item.offer_id].name : '';
      const price = map[item.offer_id] ? map[item.offer_id].prices.price : '';
      const id = map[item.offer_id] ? map[item.offer_id].id : '';

      const offer_id = map[item.offer_id] ? map[item.offer_id].offer_id : '';

      return {
        Магазин: MARKETS_MAP[shop],
        'Город отгрузки': MAP_WB_SKLAD_NAME[shop],
        'Номер задания': item.order_id,
        'Дата создания': item.date_created,
        'Название товара': name,
        'Артикул продавца': offer_id,
        'Артикул товара': id,
        Количество: 1,
        Цена: price,
        'Rid номер': item.id,
        'Стикер 1': first,
        'Стикер 2': second,
      };
    });

    const r = [...d];

    return r;
  }, [postings, dataBarcode, map]);

  const calcDownloadedDataProvider = useCallback(() => {
    let d = postings;

    d = d.map((p) => {
      const item = map[p.offer_id];

      const name = item ? item.name : '';
      const sku = item ? item.offer_id : '';
      const provider = item ? item.provider : '';
      const quantity = item ? item.quantity : '';
      const providerSku = item ? item.providerSku : '';
      const category_0 = item ? item.class : '';
      const category = item ? item.category : '';
      const purchase = item ? item.purchase : '';

      return {
        Магазин: MARKETS_MAP[shop],
        Артикул: sku,
        Наименование: name,
        Поставщик: provider,
        'Количество в заказе': quantity,
        'Артикул поставщика': providerSku,
        'Цена закупки': purchase,
        Штрихкод: p.barcode,
        Категория: category_0,
        Предмет: category,
      };
    });

    const r = [...d];

    return r;
  }, [postings, map]);

  const loadData = () => {
    PostingsWbApi.getShipmentPostings({ data: { shop: MARKETS_MAP[shop], supplyId: id } }).then((data) => {
      setSupplie(data.supplyInfo);
      setPostings(data.postings.map((p) => ({ ...p, shop: MARKETS_MAP[shop] })));

      console.log();
      setMap({ [MARKETS_MAP[shop]]: data.cardsMap });
    });
  };

  useEffect(() => {
    loadData();
  }, [id]);

  console.log(dataMeta);
  return (
    <Content>
      <H1 style={{ marginBottom: 0 }}>
        {id} {`${supplie.name}`}
      </H1>
      <LinkBlue to={`/orders/wb/supplies`} style={{ marginBottom: '10px' }}>
        Вернуться к поставкам
      </LinkBlue>
      <WhiteBlock>
        <Row style={{ alignItems: 'flex-start' }}>
          <Column style={{ marginRight: '40px', alignItems: 'flex-start' }}>
            <InputLabel fontSize={16}>Статус</InputLabel>
            {supplie.closedAt === null && <TextGrey className={styles.on_sklad}>На складе</TextGrey>}
            {supplie.closedAt && supplie.scanDt === null && <TextGrey className={styles.in_delivery}>В пути</TextGrey>}
            {supplie.closedAt && supplie.scanDt && supplie.done && (
              <TextGrey className={styles.shipped}>Отгружена</TextGrey>
            )}
          </Column>
          <Column style={{ marginRight: '40px' }}>
            <InputLabel fontSize={16} style={{ width: '170px' }}>
              Количество заказов
            </InputLabel>
            <Text fontWeight={600} fontSize={16}>
              {' '}
              {postings.length}
            </Text>
          </Column>
          <Column style={{ marginRight: '40px' }}>
            <InputLabel fontSize={16} style={{ width: '120px' }}>
              Дата создания
            </InputLabel>
            <Text fontSize={16}> {formFullDate(supplie.createdAt)}</Text>
          </Column>
          <Column>
            <InputLabel fontSize={16} style={{ width: '200px' }}>
              Время сканирования QR
            </InputLabel>
            <Text fontSize={16}>{supplie.scanDt === null ? '- ' : formFullDate(supplie.scanDt)} </Text>
          </Column>
        </Row>
      </WhiteBlock>

      <Row>
        <ExportExcelFileButton
          style={{ marginLeft: '10px' }}
          sheets={['Заказы', 'Товары']}
          filename={`Товары ${MAP_WB_SKLAD_NAME[shop]}-wb${MAP_WB[shop]} - ${postings.length}  (${formFullDate(
            new Date(),
          )})`}
          data={{
            Заказы: calcDownloadedData(),
            Товары: calcDownloadedDataProvider(),
          }}
          buttonTitle="Скачать список заказов"
        />
        <Button type={TYPE_BUTTONS.WHITE} onClick={() => setShowShipment(true)} style={{ marginLeft: '15px' }}>
          Добавить в отгрузку
        </Button>
      </Row>

      <>
        <Row spaceBetween={true}>
          <div></div>
          <Row style={{ width: 'auto', marginBottom: '15px' }}>
            <CheckButton
              checked={is_check_size}
              onSelect={() => dispatch(uiChangeWbViewSize(!is_check_size))}
              style={{ marginRight: '15px' }}
            />
            <Text style={{ marginTop: '4px' }}>Проверка габаритов</Text>
          </Row>
        </Row>
        {is_check_size ? (
          <WbTableSizes postings={postings} map={map} shop={shop} setMap={setMap} />
        ) : (
          <WbTableOrders postings={postings} map={map} shop={shop} />
        )}
      </>
    </Content>
  );
}

export default WbSuppliePage;
